import { create } from 'zustand';

interface ApiHealthState {
  consecutiveFailures: number;
  isApiDown: boolean;
  lastFailureTime: number | null;
  lastSuccessTime: number | null;
  /** Threshold of consecutive failures before showing the banner */
  failureThreshold: number;
  /** Auto-dismiss after a successful request */
  recordSuccess: () => void;
  /** Record a failed API request; triggers banner after threshold */
  recordFailure: () => void;
  /** Manually dismiss the banner */
  dismiss: () => void;
}

const FAILURE_THRESHOLD = 3;
const COOLDOWN_MS = 30_000;

export const useApiHealthStore = create<ApiHealthState>((set, get) => ({
  consecutiveFailures: 0,
  isApiDown: false,
  lastFailureTime: null,
  lastSuccessTime: null,
  failureThreshold: FAILURE_THRESHOLD,

  recordSuccess: () => {
    set({
      consecutiveFailures: 0,
      isApiDown: false,
      lastSuccessTime: Date.now(),
    });
  },

  recordFailure: () => {
    const { consecutiveFailures, lastFailureTime } = get();
    const now = Date.now();

    if (lastFailureTime && now - lastFailureTime < 200) return;

    const newCount = consecutiveFailures + 1;
    set({
      consecutiveFailures: newCount,
      lastFailureTime: now,
      isApiDown: newCount >= FAILURE_THRESHOLD,
    });
  },

  dismiss: () => {
    set({ isApiDown: false, consecutiveFailures: 0 });
  },
}));
